export function AmbientBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
    >
      {/* Two soft orbs using --color-orb-1/orb-2 tokens (warm-rose + plum,
          theme-aware). One atmospheric layer per the "one earned moment" rule. */}
      <div className="absolute -top-32 -left-24 size-[32rem] rounded-full bg-[var(--color-orb-1)] blur-[120px]" />
      <div className="absolute top-1/2 -right-32 size-[26rem] rounded-full bg-[var(--color-orb-2)] blur-[110px]" />
    </div>
  );
}
